import { useEffect } from "react";
import useLocalStorage from "./useLocalStorage";
import useTableStore from "../stores/useTableStore";

// trigger this on the page you're navigating to
export const useScrollToTable = (
    hasLoaded: boolean,
    ref?: React.MutableRefObject<HTMLDivElement | null>
) => {
    const scrollToTable = useTableStore(state => state.scrollToTable);
    const setScrollToTable = useTableStore(state => state.setScrollToTable);

    useEffect(() => {
        if (!scrollToTable) return;
        if (!ref?.current) return;

        if (hasLoaded) {
            window.scrollTo(0, ref.current.offsetTop);
            setScrollToTable(false);
        }
    }, [hasLoaded, scrollToTable]);
};
